import styled from 'styled-components';

export const MLIDashboardStyles = styled.section`
  padding: 50px;

  @media (max-width: 1440px) {
    padding: 50px 0;
  }
`;
